import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-demo-form',
	imports: [CommonModule, FormsModule],
	templateUrl: './demo-form.component.html',
	styleUrl: './demo-form.component.scss',
})
export class DemoFormComponent {
	@Input() action: any;

	datePipe = inject(DatePipe);
	currentDate: Date = new Date();
	localeDate: any = new Date().toLocaleDateString('en-IN');

	base = 'demo';		// important for API calls
	loading = false;
  frmDataX: any = {};
  frmData: any = {
    id: 0,
    inst_name: '',
    inst_type: '',
    full_name: '',
    designation: '',
    mobile_no: '',
    email_id: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    student_counts: 0,
    inst_website: '',
    source: '',
    message: '',
    pref_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
    pref_time: '12:00',
    req_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
    status: 'New',
    is_active: true
	};

	status: any = [
		"New", "Contacted", "Follow Up", "Demo Scheduled", "Interested", "Rejected", "Converted", "Closed"
	];

  constructor(public dataService: DataService) {
    //
  }

	ngOnInit() {
    // Listen to changes continuously
    this.dataService.outerAction.subscribe((value: any) => {
      if(value) {
        if(value.component != 'demo') return;

        this.action = value.action;
        this.frmData = value.data ? Object.assign({}, value.data) : this.resetForm();

        if(value.action == 'edit') {
					//
        }

        this.dataService.updateOuterAction(null);   //reset value
      }
    });
	}

  ngOnChanges() {
    if(this.action) {
      switch(this.action) {
        case 'addnew':
          // this.isReadonly = false;
          // this.frmDataSet();
          this.resetForm();
          break;
        case 'modify':
          // this.isReadonly = false;
          this.frmDataSet();
          break;
        case 'save':
          this.doSave();
          // this.isReadonly = true;
          break;
        case 'update':
          this.doUpdate();
          // this.isReadonly = true;
          break;
        case 'cancel':
          // this.isReadonly = true;
          this.resetForm();
          break;
        default:
          break;
      }

      this.action = '';
    }
  }

  frmDataSet() {
    if(this.frmData.org_name) {
      this.frmDataX = Object.assign({}, this.frmData);
    } else {
      this.frmDataX = {};
    }
  }

	resetForm() {
		this.frmData = {
			id: 0,
			inst_name: '',
			inst_type: '',
			full_name: '',
			designation: '',
			mobile_no: '',
			email_id: '',
			address: '',
			city: '',
			state: '',
			pincode: '',
			student_counts: 0,
			inst_website: '',
			source: '',
			message: '',
			pref_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
			pref_time: '12:00',
			req_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
			status: 'New',
			is_active: true
		}
	}

  doSave() {
    this.loading = true;
    // this.frmData.user_role = JSON.stringify(this.frmData.user_role);

    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		delete this.frmData.id;
    // this.frmData.user_role = JSON.stringify(this.frmData.user_role);

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }
}
